// removed by extract-text-webpack-plugin
module.exports = {"HomeItemListItem":"_3WgDGepz4B9UFBSqM6adY7","HomeItemListSubItem":"_1fDqcWBJM2QzMqfTBjNpXP","liveroom":"mTXiuBw7ezVGX8pjzBn88","photo":"As5mwsJmOcYFhLG9hoOlD","text":"_1k356L5SfCUdBH0fcmVRd9"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Category/components/CategoryRecommendLectureItemList/index.module.less
// module id = 647
// module chunks = 0